<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-BeiJingQiang2`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_8096d5df93__clip0_1283_3789)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.19482 4.82617C1.19482 3.7216 2.09025 2.82617 3.19482 2.82617H22.6138C23.7183 2.82617 24.6138 3.7216 24.6138 4.82617V6.74432C24.6138 7.84889 23.7183 8.74432 22.6138 8.74432H22.5127V19.0129C23.2138 19.3145 23.7048 20.0115 23.7048 20.8232C23.7048 21.9111 22.8229 22.793 21.7351 22.793H4.07348C2.98563 22.793 2.10376 21.9111 2.10376 20.8232C2.10376 20.0116 2.59467 19.3146 3.29578 19.013V8.74432H3.19482C2.09025 8.74432 1.19482 7.84889 1.19482 6.74432V4.82617ZM5.04468 8.74432V18.8535H20.7638V8.74432H5.04468ZM2.94482 5.53906C2.94482 4.98678 3.39254 4.53906 3.94482 4.53906H21.8728C22.4251 4.53906 22.8728 4.98678 22.8728 5.53906V6.03125C22.8728 6.58353 22.4251 7.03125 21.8728 7.03125H3.94482C3.39254 7.03125 2.94482 6.58353 2.94482 6.03125V5.53906ZM3.81689 20.8231C3.81689 20.6112 3.98868 20.4395 4.20058 20.4395H21.608C21.8199 20.4395 21.9917 20.6112 21.9917 20.8231C21.9917 21.035 21.8199 21.2068 21.608 21.2068H4.20058C3.98867 21.2068 3.81689 21.035 3.81689 20.8231Z"/></g><defs><clipPath id="svg_8096d5df93__clip0_1283_3789"><path transform="translate(.614 .81)" d="M0 0H24V24H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconBeiJingQiang2',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
